import { StepBase } from './StepBase';
import { PageStepType } from './PageTypes';
import { LogicEngine } from '../LogicEngine/LogicEngine';
import { DataRecord } from '../utils/DataRecord';
import { DataSet } from '../utils/DataSet';

interface callbackRow
{
	(record: DataRecord): Promise<any>;
}

export class StepTest extends StepBase
{
	// Reference to the logic engine
	logicRef: LogicEngine | undefined;

	// Callback function for each record to pre-process it before adding to the data set
	evRecordCallback: callbackRow | undefined;

	// Optional settings from the "Option"
	listOptions: { [keyName: string]: string } = {};

	// Name of this specific test
	testName : string | undefined;

	testSteps : PageStepType[] = [];

	/** Add a column to the list of tabs we're tracking in this holder */
	async addOption(step: PageStepType)
	{
		if (!this.logicRef)
			throw "Exception: should not happen but logicRef in StepTest is null";

		// Key is the configuration lookup key
		let key = step.step_option ? step.step_option : "";
		key = key.toLowerCase().trim();

		// Value from the text_en column
		let value = step.text_en ? this.logicRef.processTextReplacement(step.text_en) : (step.option_1 ? step.option_1 : "");
		this.listOptions[key] = value;
	}

	async processEndTest(logic: LogicEngine)
	{
	}

	addStep(step: PageStepType)
	{
		this.testSteps.push(step);
	}

	/**
	 *  Process the data type here.
	 *  Load the data related to the Query data type.
	 */

	async processStep(logic: LogicEngine): Promise<boolean>
	{
		this.logicRef = logic;
		await super.processStep(logic);
		this.testName = this.text.trim();
		return false;
	}
}
